import PropTypes from "prop-types";
import { Grid, IconButton } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { animateScroll as scroll } from "react-scroll";

const VerticalArrows = ({ getDuration }) => {
  return (
    <Grid container flexDirection="column" rowGap={20} sx={{ width: "10%" }}>
      <IconButton
        aria-label="previous"
        color="primary"
        onClick={() => scroll.scrollMore(-194, { duration: -getDuration, containerId: "scroll-container" })}
        size="large"
      >
        <KeyboardArrowUpIcon sx={{ fontSize: 60 }} />
      </IconButton>
      <IconButton
        aria-label="next"
        color="primary"
        onClick={() => scroll.scrollMore(194, { duration: getDuration, containerId: "scroll-container" })}
        size="large"
      >
        <KeyboardArrowDownIcon sx={{ fontSize: 60 }} />
      </IconButton>
    </Grid>
  );
};

VerticalArrows.propTypes = {
  getDuration: PropTypes.func.isRequired,
};

export default VerticalArrows;
